import { useEffect, useState } from 'react';
import { useParams } from 'react-router';
import $window from '../utils/window';

export default function useProperty(fieldName, defaultValue) {
  const params = useParams();
  const [value, setValue] = useState(defaultValue);
  useEffect(() => {
    if (typeof params === 'object'
      && params !== null
      && fieldName in params
      && params[fieldName] !== undefined
      && params[fieldName] !== null) {
      setValue(params[fieldName]);
      return;
    }
    const regex = new RegExp(`${fieldName}=([^&]+)`);
    if ($window.location.search.match(regex)) {
      const [, fieldValue] = $window.location.search.match(regex);
      setValue(fieldValue);
    }
  }, [$window.location.search, params, fieldName]);
  return [value, setValue];
}
